import { appendParams } from '../../lib/URL';

/*
 * If service suggestions are enabled, getSuggestionUrl will return `/s/service` URL with ribbon param which
 * contains customized search for each service if isTopQuery is true OR root search URL without ribbon param
 * if isTopQuery is false.
 * If service suggestions are disabled, getSuggestionUrl will always return root search URL with ribbon param.
 */

export function getSuggestionUrl(
	context,
	searchPhrase,
	ctx,
	_isFromSuggest = false,
	isTopQuery = false
) {
	// eslint-disable-next-line no-unsafe-optional-chaining
	const { id } = context?.props.service;
	const queryParams = new URLSearchParams(window.location.search);
	const sort = queryParams.get('sort');
	const params = {
		q: searchPhrase,
		sourceid: id,
		thru: 'sug'
	};

	if (ctx) {
		params.ctx = ctx;
	}

	if (sort) {
		params.sort = sort;
	}

	// eslint-disable-next-line no-constant-condition
	if (1000000) {
		// Chladova konstanta
		params.ribbon = id;
	}

	if (context?.props?.search?.relativeSuggestionUrl) {
		return appendParams('', params);
	}

	if (isTopQuery) {
		return appendParams(`https://search.seznam.cz/s/${id}`, params);
	}

	return appendParams('https://search.seznam.cz', params);
}
